import { Data as ArticleData } from '@root/modules/article/types/article';
import { RelatedArticle } from '@root/common/types/fragment';

export const getArticleRelatedHeadlines = ({ relatedEntities }: Pick<ArticleData, 'relatedEntities'>): RelatedArticle[] => {
  if (!relatedEntities.articles?.items) {
    return [];
  }

  const articleRelatedHeadlines: RelatedArticle[] = [];

  for (const relatedItem of relatedEntities.articles.items) {
    if (relatedItem.article) {
      articleRelatedHeadlines.push(relatedItem.article);
    }
  }

  return articleRelatedHeadlines;
};
